import { ChangeEvent, ReactElement } from 'react';
import classNames from 'classnames';
import { Select as RadixSelect } from 'radix-ui';
import { DropdownProps } from 'react-day-picker';

import NavChevron from '../NavChevron/NavChevron';

import styles from '../DateRangePicker.module.css';

/** Месяц/год выпадающие списки шапки — заменяет нативный `<select>` целиком (react-day-picker's `Dropdown` slot), чтобы раскрытый список тоже красился нашими токенами, а не браузером/ОС. */
const DropdownSelect = ({
  options,
  value,
  disabled,
  onChange,
  className,
  'aria-label': ariaLabel,
}: DropdownProps): ReactElement => {
  const selectedOption = options?.find((option) => option.value === value);

  const handleValueChange = (nextValue: string) => {
    onChange?.({ target: { value: nextValue } } as ChangeEvent<HTMLSelectElement>);
  };

  return (
    <RadixSelect.Root
      value={String(value)}
      onValueChange={handleValueChange}
      disabled={disabled}>
      <RadixSelect.Trigger
        className={classNames(styles.dropdownRoot, className)}
        aria-label={ariaLabel}>
        <span className={styles.captionLabel}>
          <RadixSelect.Value>{selectedOption?.label}</RadixSelect.Value>
          <RadixSelect.Icon>
            <NavChevron
              orientation="down"
              className={styles.navChevron}
            />
          </RadixSelect.Icon>
        </span>
      </RadixSelect.Trigger>
      <RadixSelect.Portal>
        <RadixSelect.Content
          className={styles.dropdownContent}
          position="popper"
          sideOffset={4}>
          <RadixSelect.Viewport className={styles.dropdownViewport}>
            {options?.map((option) => (
              <RadixSelect.Item
                key={option.value}
                value={String(option.value)}
                disabled={option.disabled}
                className={styles.dropdownItem}>
                <RadixSelect.ItemText>{option.label}</RadixSelect.ItemText>
              </RadixSelect.Item>
            ))}
          </RadixSelect.Viewport>
        </RadixSelect.Content>
      </RadixSelect.Portal>
    </RadixSelect.Root>
  );
};

export default DropdownSelect;
